<template>
  <div class="brand-promotion-component">
    <div class="brand-section app-basic-layout-wrapper">
      <h3 class="title font-30">推广场景</h3>
      <p class="subtitle">
        从兴趣用户到品牌内容共创用户的转化，品牌号实现公私域流转，沉淀社交资产
      </p>
      <div class="body">
        <div class="item-wrapper">
          <div class="icon-image">
            <img src="@/assets/img/brand/changjing1.png" />
          </div>
          <h3 class="item-title">明星代言人</h3>
          <p class="desc">
            借助明星周边奖品，通过用户参与发布带话题博文，制造公域声量
          </p>
        </div>
        <div class="item-wrapper">
          <div class="icon-image">
            <img src="@/assets/img/brand/changjing2.png" />
          </div>
          <h3 class="item-title">产品上新</h3>
          <p class="desc">
            借助新品体验奖品，吸引用户参与测评，用户测评内容引发全网热议
          </p>
        </div>
        <div class="item-wrapper">
          <div class="icon-image">
            <img src="@/assets/img/brand/changjing3.png" />
          </div>
          <h3 class="item-title">游戏场景</h3>
          <p class="desc">游戏限量奖品促进粉丝完成任务，话题任务引发用户讨论</p>
        </div>
        <div class="item-wrapper">
          <div class="icon-image">
            <img src="@/assets/img/brand/changjing4.png" />
          </div>
          <h3 class="item-title">直播场景</h3>
          <p class="desc">
            秀场周边激励用户完成直播任务，直播后片段引发全网热议
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.body {
  padding-top: 60px;
  display: flex;
  justify-content: space-between;
  .item-wrapper {
    width: 248px;
    height: 201px;
    .icon-image {
      height: 81px;
      overflow: hidden;
      text-align: center;
      margin-bottom: 24px;
      img {
        height: 100%;
        object-fit: cover;
      }
    }
    .item-title {
      font-size: 24px;
      text-align: center;
      margin-bottom: 16px;
    }
    .desc {
      font-size: 16px;
      text-align: center;
    }
  }
}
</style>
